<template>
    <div>
        <div class="row align-items-center">
            <div class="col">
                <div class="intro">
                    <h1>Werkgeverslasten</h1>
                    <p>Pas de werkgeverslasten van een Rockstar aan.</p>
                </div>
            </div>
            <div class="col-md-6">
                <RockEmployeeSelection v-model="selectedEmployee" />
            </div>
        </div>
        <div
            :class="{
                'rock-alter-employer-charges': true,
                'mb-4': true,
                'rock-alter-employer-charges-loading': loading
            }"
        >
            <template v-if="!loading">
                <table v-if="serviceYears.length > 0" class="table mb-0">
                    <thead>
                        <tr>
                            <th class="w-100">Dienstjaar</th>
                            <th>Werkgeverslasten</th>
                            <th />
                        </tr>
                    </thead>
                    <tr
                        v-for="serviceYear in serviceYears"
                        :key="serviceYear.id"
                    >
                        <td class="align-middle">
                            {{ formatYear(serviceYear.startDate) }}-{{
                                formatYear(serviceYear.endDate)
                            }}
                        </td>
                        <td>
                            <form
                                v-if="
                                    serviceYear.serviceYear ===
                                    selectedServiceYear.serviceYear
                                "
                                :id="`serviceYearUpdateForm_${serviceYear.serviceYear}`"
                                class="form--charges"
                                @submit.prevent="handleSaveServiceYear"
                            >
                                <input
                                    :id="`serviceYear${serviceYear.serviceYear}`"
                                    v-model="selectedServiceYear.charges"
                                    type="number"
                                    required
                                    pattern="^[0-9]+$"
                                    max="100"
                                    min="0"
                                    @input="handleServiceYearChargesInput"
                                />
                                <span class="form-group__affix">%</span>
                            </form>
                            <template v-else
                                >{{ serviceYear.charges }} %</template
                            >
                        </td>
                        <td>
                            <div class="d-flex justify-content-end">
                                <template
                                    v-if="
                                        serviceYear.serviceYear ===
                                        selectedServiceYear.serviceYear
                                    "
                                >
                                    <button
                                        :disabled="updating"
                                        class="btn btn-reset btn-small mr-1"
                                        @click="handleServiceYearCancel"
                                    >
                                        Annuleer
                                    </button>
                                    <button
                                        class="btn btn-secondary btn-small no-arrow"
                                        :form="`serviceYearUpdateForm_${serviceYear.serviceYear}`"
                                        type="submit"
                                        :disabled="updating"
                                    >
                                        Opslaan
                                    </button>
                                </template>
                                <button
                                    v-else
                                    class="btn btn-secondary btn-small no-arrow"
                                    @click="
                                        handleSelectServiceYear(serviceYear)
                                    "
                                >
                                    Aanpassen
                                </button>
                            </div>
                        </td>
                    </tr>
                </table>
                <div v-else class="p-5">
                    <h2 class="mb-0">Kies een rockstar.</h2>
                </div>
            </template>
            <RockSpinner v-else />
        </div>
    </div>
</template>

<script>
import RockEmployeeSelection from '@/components/RockEmployeeSelection';
import RockSpinner from '@/components/RockSpinner';
import RockDates from '@/mixins/RockDates';
import RockCurrency from '@/mixins/RockCurrencyMixin';

export default {
    components: {
        RockSpinner,
        RockEmployeeSelection
    },

    mixins: [RockDates, RockCurrency],

    data: () => ({
        loading: true,
        updating: false,
        selectedEmployee: null,
        serviceYears: [],
        employees: [],
        selectedServiceYear: {
            serviceYear: null
        }
    }),

    watch: {
        selectedEmployee(newValue, oldValue) {
            this.handleServiceYearCancel();
            if (
                !oldValue ||
                (oldValue && newValue.employeeId !== oldValue.employeeId)
            ) {
                this.getServiceYears().catch(() => {
                    this.selectedEmployee = oldValue;
                });
            }
        }
    },

    methods: {
        handleServiceYearCancel() {
            this.selectedServiceYear = { serviceYear: null };
        },

        handleSaveServiceYear() {
            this.putServiceYear();
        },

        handleServiceYearChargesInput(event) {
            const input = event.target;
            if (input.validity.patternMismatch) {
                input.setCustomValidity(
                    'Alleen absolute getallen, geen kommagetallen a.u.b.'
                );
            } else {
                input.setCustomValidity('');
            }
        },

        handleSelectServiceYear(serviceYear) {
            this.selectedServiceYear = { ...serviceYear };
        },

        getServiceYears() {
            const self = this;
            self.loading = true;
            return this.$http
                .get(
                    `/employees/${self.selectedEmployee.employeeId}/serviceyears`
                )
                .then(({ data }) => {
                    self.serviceYears = data.filter(
                        ({ endDate }) => new Date(endDate) < new Date()
                    );
                })
                .catch((error) => {
                    if (error.message !== 'ABORTED') {
                        this.loading = false;
                        console.log(error);
                    }
                    alert(
                        'De geselecteerde gebruiker kon niet worden geladen.'
                    );
                    return Promise.reject(error);
                })
                .finally(() => {
                    self.loading = false;
                });
        },

        putServiceYear() {
            const self = this;
            if (
                !self.selectedServiceYear ||
                !self.selectedServiceYear.serviceYear
            )
                return;
            const { charges, serviceYear } = self.selectedServiceYear;
            const url = [
                'employees',
                self.selectedEmployee.employeeId,
                'serviceyears',
                serviceYear
            ].join('/');

            self.updating = true;

            return this.$http
                .put(url, { charges })
                .then(({ data }) => {
                    self.serviceYears.find(
                        ({ serviceYear: serviceYearId }) =>
                            serviceYear === serviceYearId
                    ).charges = charges;
                    self.handleServiceYearCancel();
                })
                .catch((error) => console.error(error))
                .finally(() => {
                    self.updating = false;
                });
        }
    }
};
</script>

<style lang="scss">
.rock-alter-employer-charges {
    position: relative;
    background: rgba(#232323, 0.9);

    &.rock-alter-employer-charges-loading {
        height: 9rem;

        .backdrop {
            background-color: transparent;
        }
    }
}

.form--charges {
    display: flex;
    align-items: center;
}

.form-group__affix {
    margin-left: 0.5rem;
}
</style>
